<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-popup class="holamundo" :title="$t(`MODULE_ROLE.${titleModal}`)" :active.sync="addNewDataSidebar">
			<div class="p-2 py-0">
				<vs-input
					:label="$t(`MODULE_ROLE.labelName`)"
					v-model="rol.name"
					class="mt-5 w-full"
					name="item-name"
					v-validate="'required'"
				/>
				<span class="text-danger text-sm" v-show="errors.has('item-name')">{{
					$t(`MODULE_ROLE.ValidName`)
				}}</span>

				<vs-textarea
					v-model="rol.description"
					:label="$t(`MODULE_ROLE.labelDescription`)"
					class="mt-5 w-full"
					name="item-description"
					v-validate="'required'"
				/>
				<span class="text-danger text-sm" v-show="errors.has('item-description')">{{
					$t(`MODULE_ROLE.ValidDescription`)
				}}</span>

				<div class="flex justify-end">
					<vs-button class="mr-5" color="success" type="border" @click="createRol">{{
						btnModalsubmit ? $t(`MODULE_ROLE.Ok`) : $t(`MODULE_ROLE.Update`)
					}}</vs-button>
					<vs-button color="danger" type="border" @click="addNewDataSidebar = false">{{
						$t(`MODULE_ROLE.Cancel`)
					}}</vs-button>
				</div>
			</div>
		</vs-popup>

		<div id="div-with-loading-rol" class="vs-con-loading__container">
			<vs-table ref="table" pagination :max-items="itemsPerPage" search :data="roles">
				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
					<div class="flex flex-wrap-reverse items-center data-list-btn-container"></div>

					<!-- ITEMS PER PAGE -->
					<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
						<div
							class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
						>
							<span class="mr-2"
								>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
								-
								{{
									roles.length - currentPage * itemsPerPage > 0
										? currentPage * itemsPerPage
										: roles.length
								}}
								{{ $t("Of") }} {{ queriedItems }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>

						<vs-dropdown-menu>
							<vs-dropdown-item @click="itemsPerPage = 4">
								<span>4</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 10">
								<span>10</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 15">
								<span>15</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 20">
								<span>20</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>

				<template slot="thead">
					<vs-th sort-key="name">{{ $t("MODULE_ROLE.Role") }}</vs-th>
					<vs-th sort-key="category">{{ $t("MODULE_ROLE.Description") }}</vs-th>
					<vs-th sort-key="popularity">{{ $t("MODULE_ROLE.Created") }}</vs-th>
					<vs-th v-if="roleUpdatePermission || roleDeletePermission">{{ $t("MODULE_ROLE.Action") }}</vs-th>
				</template>

				<template slot-scope="{data}">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td>
								<p class="product-name font-medium truncate">
									{{ tr.name }}
								</p>
							</vs-td>

							<vs-td>
								<p class="product-category">
									{{ tr.description }}
								</p>
							</vs-td>

							<vs-td>
								<p class="product-price">
									{{ tr.added_on | formarDate }}
								</p>
							</vs-td>
							<vs-td v-if="roleUpdatePermission || roleDeletePermission" class="whitespace-no-wrap">
								<feather-icon
									v-if="roleUpdatePermission"
									icon="EditIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="editData(tr)"
								/>
								<feather-icon
									v-if="roleDeletePermission"
									icon="TrashIcon"
									svgClasses="w-5 h-5 hover:text-danger stroke-current"
									class="ml-2"
									@click.stop="deleteData(tr.id)"
								/>
							</vs-td>
							<template class="expand-user" slot="expand" v-if="rolePermission != []">
								<div class="con-expand-users w-full">
									<div v-for="(cat, key) in rolePermission" :key="key">
										<vs-chip v-if="tr.id == cat.role_id" transparent color="primary">
											{{ cat.permission_name }}
										</vs-chip>
									</div>
								</div>
							</template>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</div>
	</div>
</template>

<script>
import moduleRole from "@/store/roles/moduleRole.js";

import {Validator} from "vee-validate";

const dict = {
	custom: {
		"item-name": {
			required: "ErrorName",
		},
		"item-description": {
			required: "ErrorDescription",
		},
	},
};

Validator.localize("en", dict);

export default {
	data() {
		return {
			titleModal: "TitleCrear",
			idUpdate: "",
			idDelete: "",
			rol: {
				name: "",
				description: "",
			},
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			addNewDataSidebar: false,
			data: [],
		};
	},
	computed: {
		btnModalsubmit() {
			return this.titleModal === "TitleCrear";
		},
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		roles() {
			return this.$store.state.dataRoles.roles;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.roles.length;
		},
		rolePermission() {
			return this.$store.state.dataRoles.rolepermission;
		},
		roleUpdatePermission() {
			return this.$store.getters.checkPermission("ROLE_U");
		},
		roleDeletePermission() {
			return this.$store.getters.checkPermission("ROLE_D");
		},
	},
	methods: {
		openModal(bool) {
			this.addNewDataSidebar = bool;
		},
		async createRol() {
			try {
				const result = await this.$validator.validateAll();
				if (result) {
					this.addNewDataSidebar = false;
					this.$vs.loading({
						container: "#div-with-loading-rol",
						scale: 1,
						type: "sound",
					});

					if (this.btnModalsubmit) {
						this.$store
							.dispatch("dataRoles/createRol", this.rol)
							.then((r) => {
								this.notyfy(this.$t("MODULE_ROLE.Hecho"), this.$t("MODULE_ROLE.msgHecho"));
								this.idUpdate = "";
								this.rol = {
									name: "",
									description: "",
								};
								this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
							})
							.catch((error) => {
								console.error("CREATE ROL ERROR", error);
							});
					} else {
						const data = {
							id: this.idUpdate,
							payload: this.rol,
						};
						this.$store
							.dispatch("dataRoles/updateRol", data)
							.then((r) => {
								this.idUpdate = "";
								this.rol = {
									name: "",
									description: "",
								};
								this.notyfy(this.$t("MODULE_ROLE.Change"), this.$t("MODULE_ROLE.msgChange"));
								this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
							})
							.catch((error) => {
								console.error("ROL UPDATE ERROR", error);
							});
					}
				}
			} catch (e) {
				// statements
				console.error(e);
			} finally {
				this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
			}
		},
		deleteData(id) {
			this.idDelete = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t(`MODULE_ROLE.titleDelete`),
				text: this.$t(`MODULE_ROLE.msgDelete`),
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		async acceptAlert() {
			try {
				this.$vs.loading({
					container: "#div-with-loading-rol",
					scale: 1,
					type: "sound",
				});
				await this.$store.dispatch("dataRoles/deleteRol", this.idDelete);
				this.notyfy(this.$t("MODULE_ROLE.Removed"), this.$t("MODULE_ROLE.msgRemoved"));
			} catch (e) {
				// statements
				console.error(e);
			} finally {
				this.$vs.loading.close("#div-with-loading-rol > .con-vs-loading");
				this.idDelete = "";
			}
		},
		addNewData() {
			this.$router.push({name: "CreateRole"});
		},
		editData(data) {
			this.titleModal = "TitleUpdate";
			this.idUpdate = data.id;
			this.rol = {
				name: data.name,
				description: data.description,
			};
			let role = {
				id: data.id,
				name: data.name,
				alias: data.alias,
				description: data.description,
				permissions: this.rolePermission.filter((permission) => permission.role_id == data.id),
			};
			this.$router.push({name: "UpdateRole", params: {data: role}});
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
		notyfy(title, text, color = "success", position = "bottom-right") {
			this.$vs.notify({
				color: color,
				title: title,
				text: text,
				position: position,
			});
		},
		getRoles() {
			this.$vs.loading();
			this.$store
				.dispatch("dataRoles/getRoles")
				.then((res) => {
					this.consultRolePermission();
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("MODULE_ROLE.ErrorMessages.ConsultRoles"),
					});
				});
		},
		consultRolePermission() {
			this.$store
				.dispatch("dataRoles/getRolPermission")
				.then((res) => {
					this.$vs.loading.close();
				})
				.catch((err) => {
					console.error(err);
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("MODULE_ROLE.ErrorMessages.ConsultRolePermissions"),
					});
				});
		},
	},
	created() {
		if (!moduleRole.isRegistered) {
			this.$store.registerModule("dataRoles", moduleRole);
			moduleRole.isRegistered = true;
		}
		this.getRoles();
	},
	mounted() {
		this.isMounted = true;
		this.data = this.roles;
	},
};
</script>

<style lang="scss">
//@import './style.scss';
#data-list-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
